export default __webpack_public_path__ + "static/partnerIcon8-9f581c6a2f2255fde4ab22bab4d3086f.svg";